import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import {
    useFetchReferralUserMutation
} from "../../../features/tenant/ReferEarn/referEarn.api";
import { toast } from "react-hot-toast";

const ReferUser = () => {
    const [allUsers, setAllUsers] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [fetchReferralUser, { data: referralUserData, isLoading: referralUserLoading, error: referralUserError }] =
        useFetchReferralUserMutation();

    useEffect(() => {
        if (referralUserLoading) {
            toast.dismiss();
            toast.loading("loading ...", {
                id: "delete loading "
            });
        }
        if (referralUserData) {
           toast.dismiss();
           console.log(referralUserData.body.data)
            setAllUsers(referralUserData.body.data)
            setTotalCount(referralUserData.body.totalCount)

        }

    }, [referralUserLoading]);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const initialRequest = {
        limit: 10,
        offset: 0,
        mobile: ""
    };
    const [request, setRequest] = useState(initialRequest);

    useEffect(() => {
        fetchReferData();
        // fetchAppUserByUserTypeCsvFunction();
    }, [limit, offset]);

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setCurrentPage(pageNumber);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
    };


    const fetchReferData = (requestData=request) => {
        // request["limit"] = limit;
        // request["offset"] = offset;
        fetchReferralUser({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            limit: requestData.limit,
            offset: requestData.offset,
            mobile: requestData.mobile
        });
    };

    const clearFilters = () => {
        setRequest(initialRequest);
        fetchReferData(initialRequest)
    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "User Id",
            cell: (row) => <div>{row.user_id}</div>,
            sortable: true,
        },
        {
            name: "Name",
            cell: (row) => <div>{row.name}</div>,
            sortable: true,
        },
        {
            name: "Mobile",
            cell: (row) => row.mobile,
            sortable: true,
        },
        {
            name: "Refer User id",
            cell: (row) => row.refer_user_id,
            sortable: true,
        },
        {
            name: "Refer Name",
            cell: (row) => row.refer_name,
            sortable: true,
        },
        {
            name: "Refer Mobile",
            cell: (row) => row.refer_mobile,
            sortable: true,
        }];


    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Refer Users
                        <LinksComponent />
                    </div>

                    <div className="p-3 ">

                        <div className=" w-full bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex  space-x-2 ">
                                    <div className="w-52 ">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Mobile No
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                                placeholder="Mobile..."
                                                required
                                                value={request.mobile}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, mobile: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            &nbsp;
                                        </label>

                                        <div className="flex flex-row  gap-2 ">
                                            <div className="relative searchin">
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                                                    onClick={() => {
                                                        fetchReferData();
                                                        // fetchAppUserByUserTypeCsvFunction();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="relative searchin">
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                                    onClick={() => {
                                                        clearFilters();
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="p-3">
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    data={allUsers.length && allUsers}
                                    totalRows={totalCount}
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={paginationResetToggle}
                                ></DataTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferUser;
